import { gql } from '@apollo/client'

import { UNKNOWN_WORD_LIST_FRAGMENT } from '../fragments'

const UNCONFIRM_UNKNOWN_WORD_MUTATION = gql`
  mutation unconfirmUnknownWordMutation($id: ID!) {
    unconfirmUnknownWord(id: $id) {
      ...UnknownWordListFragment
    }
  }
  ${UNKNOWN_WORD_LIST_FRAGMENT}
`

export default UNCONFIRM_UNKNOWN_WORD_MUTATION
